<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-formula`]" width="1em" height="1em" v-bind="$attrs"><path d="M25.927 24L7.725 9.398A2.5 2.5 0 019.352 5H40a1 1 0 011 1v2a1 1 0 01-1 1H13.407l17.696 14.22a1 1 0 010 1.56L13.406 39H40a1 1 0 011 1v2a1 1 0 01-1 1H9.352a2.5 2.5 0 01-1.627-4.398L25.927 24z"/></svg>
</template>
<script>

export default {
  name: 'IconFormula',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
